<template lang="pug">
system-tabs(section="/system/tickets")
    el-card.contains-table(shadow="always")
        project-list(scope="system")
</template>

<script>
import SystemTabs from '@/views/system/Partials/Tabs';
import ProjectList from '@/extensions/tickets/views/Projects/ProjectList';

/**
 * Chrome only. `/system/tickets/projects` is a top-level route (like the
 * gantt), so it renders its own tab bar, marked on Tickets - a project belongs
 * to the ticket section rather than beside it.
 */
export default {
    name: 'SystemProjectList',
    components: {
        SystemTabs,
        'project-list': ProjectList,
    },
};
</script>
